import React from 'react'
import PT from 'prop-types'

import styles from './styles.css'

const VehicleColumnLabel = ({ vehicle }) => (
  <h3 className={styles.title}>
    <div key='licenseplate'>
      {[
        vehicle.details.licenseplate,
        vehicle.name ? `(${vehicle.name})` : null,
      ].join(' ')}
    </div>
    <div key='name'>
      {`${vehicle.details.make} ${vehicle.details.model}`}
    </div>
  </h3>
)

VehicleColumnLabel.propTypes = {
  vehicle: PT.shape({
    name: PT.string.isRequired,
    details: PT.shape({
      licenseplate: PT.string.isRequired,
      make: PT.string.isRequired,
      model: PT.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default VehicleColumnLabel
